import { Directive, ElementRef, HostBinding, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appHiddenInput]',
  exportAs: 'hiddenInput'
})
export class HiddenInputDirective {

  @HostBinding('class.focussed') focussed: boolean = false;

  constructor(
    private _renderer: Renderer2,
    public hostElement: ElementRef
  ) {
    _renderer.addClass(hostElement.nativeElement, 'hidden-input');
  }

  focus(){
    this.focussed = true;
    setTimeout(() => {
      this
      .hostElement
      .nativeElement
      .focus();
    }, 1);
  }

  @HostListener('blur', ['$event'])
  onBlur() {
    this.focussed = false;
  }

}
